import { render, staticRenderFns } from "./SnapshotExtractions.vue?vue&type=template&id=7877ba35"
import script from "./SnapshotExtractions.vue?vue&type=script&lang=js"
export * from "./SnapshotExtractions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports